import { client } from '@hotjar/api-base-client';
import { clientBaseConfig } from './base';
import type { OrderRequestDto } from './dto';
import type { OrderProcessResponse, SubscriptionCancellationRequest } from './model';

export async function cancelSubscription(
  data: SubscriptionCancellationRequest,
): Promise<OrderProcessResponse> {
  return client<
    OrderProcessResponse,
    null,
    SubscriptionCancellationRequest,
    OrderRequestDto<'cancel_subscription_order'>
  >({
    ...clientBaseConfig,
    data,
    mapRequestData: ({ hotjarAccountId }) => ({
      cancel_subscription_order: {
        hotjar_account_id: hotjarAccountId,
      },
    }),
  });
}
